document.addEventListener('DOMContentLoaded', () => {

    let $subitemTrigger = document.querySelectorAll('.has-dropdown.is-hoverable');
    if ($subitemTrigger.length > 0) {
      $subitemTrigger.forEach(($el) => {
        $el.addEventListener('click', function () {
          let $target = $el.querySelector('.navbar-dropdown');;
          $el.classList.toggle('is-clicked');
          $target.classList.toggle('is-active');
        }, {passive: true});
      });
    }

    let $subitemsTrigger = document.querySelectorAll('.has-subitems');
    let $subitemsTarget = document.querySelectorAll('.subitems');

    if ($subitemsTrigger.length > 0) {
      $subitemsTrigger.forEach(($el) => {
        $el.addEventListener('click', function () {
          let $target = $el.nextElementSibling;
          $el.classList.toggle('is-clicked');
          $target.classList.toggle('is-active');
        }, {passive: true});
      });
    }
}, {passive: true});
